/* eslint-disable class-methods-use-this */
import React, { PropTypes, Component } from 'react'
import Heading from 'components/Heading'
import Table from 'components/Table'
import Card from 'components/Card'
// import moment from 'moment'
import { format, parse } from 'date-fns'
import constants from 'constants'
import { IconEPICDocument } from '../../../../icons'

const styles = Object.assign(
  {},
  { columns: require('../columns.scss') },
  { table: require('components/Table/Table.scss') },
)

export class DocumentCard extends Component {
  static propTypes = {
    documentTitle: PropTypes.string,
    partnerPlanDocuments: PropTypes.obj,
  }
  static defaultProps = {
    partnerPlanDocuments: [],
    documentTitle: '',
  }

  render() {
    const { partnerPlanDocuments, documentTitle } = this.props
    if (partnerPlanDocuments && partnerPlanDocuments.length > 0) {
      return (
        <section className={styles.plandocuments}>
          <Heading noTopPadding>{documentTitle}</Heading>
          <Card noPadding>
            <Table>
              { partnerPlanDocuments.map(doc => (
                <tr className={styles.base} key={doc.itemId}>
                  <td className={styles.columns.docIcon}><IconEPICDocument height="18" width="18" /></td>
                  <td className={styles.columns.docLink}>
                    <div><a href={doc.path} rel="noopener noreferrer" target="_blank" title={doc.documentName}>{doc.documentName}</a></div>
                    <div className={styles.columns.docDate}>Uploaded: {(doc.modifiedDate ? format(parse(doc.modifiedDate, constants.DATE_FORMAT.SPO_FORMAT, new Date()), constants.DATE_FORMAT.PARTNER_PLAN_DOCLIST) : '')}</div>
                  </td>                  
                </tr>
            )) }
            </Table>
          </Card>
        </section>
      )
    }
    return (<div />)
  }
}

export default DocumentCard



// WEBPACK FOOTER //
// ./src/views/PartnerReports/PartnerPlan/components/DocumentCard.js